import {
  useSignUpGuestStore,
  useValidateStep,
  ZGuestInfoForm,
  TGuestInfoForm,
  TTermsForm,
} from '@/features/sign-up'

const GUEST_STEP_PATHS: Record<string, number> = {
  intro: 0,
  terms: 1,
  info: 2,
  verification: 3,
  complete: 4,
}

const validateTermsStep = (terms: TTermsForm) => {
  const isRequiredAllChecked =
    terms.termsOfService && terms.privacyConsent && terms.ageOver19

  return isRequiredAllChecked
}

const validateGuestInfoStep = (info: TGuestInfoForm) => {
  const { success } = ZGuestInfoForm.safeParse(info)

  return success
}

export const useValidateGuestStep = () => {
  const { terms, info } = useSignUpGuestStore()

  useValidateStep(GUEST_STEP_PATHS, [
    {
      step: 2,
      validate: () => validateTermsStep(terms),
      redirect: `/sign-up/guest?step=terms`,
    },
    {
      step: 3,
      validate: () => validateGuestInfoStep(info),
      redirect: `/sign-up/guest?step=info`,
    },
  ])
}
